
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-lavender-200 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/50592d64-beb7-4d86-8bbd-f498345c88c9.png"
              alt="Flan Cake"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-700 leading-relaxed">
              將南美經典甜點 Flan Cake 帶入台灣，用傳統工藝與創新精神，為您呈現最道地的美味體驗
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase">產品系列</h4>
            <ul className="space-y-3">
              <li><Link to="/shop" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">經典原味</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">咖啡口味</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">抹茶口味</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">水果系列</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase">服務項目</h4>
            <ul className="space-y-3">
              <li><Link to="/shop" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">線上購物</Link></li>
              <li><Link to="/stores" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">門市據點</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">企業訂購</Link></li>
              <li><Link to="/franchise" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">加盟資訊</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase">關於我們</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">品牌故事</Link></li>
              <li><Link to="/about" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">甜點歷史</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">聯絡我們</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">常見問題</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-lavender-300 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4 text-sm text-gray-700">
            <span>© 2025 Flan Cake. All rights reserved.</span>
            <span className="hidden md:inline">|</span>
            <a href="#" className="hover:text-lavender-700 transition-colors cursor-pointer">隱私政策</a>
            <span>|</span>
            <a href="#" className="hover:text-lavender-700 transition-colors cursor-pointer">服務條款</a>
            <span>|</span>
            <a href="#" className="hover:text-lavender-700 transition-colors cursor-pointer">Cookie 政策</a>
            <span>|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-lavender-700 transition-colors cursor-pointer">Powered by Readdy</a>
          </div>

          <div className="flex items-center gap-4">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-gray-700 hover:text-lavender-700 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
